import React, { SyntheticEvent } from 'react';
import { Tooltip } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';
import { NavItemSecond } from './styles';
interface Props {
  trigger: JSX.Element;
  onIPOClick: () => void;
  onPreIPOClick: () => void;
}

export function TooltipHowItWorks(props: Props) {
  const { trigger, onIPOClick, onPreIPOClick } = props;
  const { t } = useTranslation('header');

  return (
    <Tooltip
      on="click"
      padding={[10, 0, 10]}
      width={200}
      trigger={trigger}
      isArrow={false}
      position="bottom-start"
      offset={0}
      offsetSkidding={-20}
    >
      <div>
        <NavItemSecond isDisabled={true}>{t('About UT Platform')}</NavItemSecond>

        <NavItemSecond
          href="/how-it-works/ipo/ipo-investments"
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            onIPOClick();
          }}
        >
          {t('IPO')}
        </NavItemSecond>

        <NavItemSecond
          href="/how-it-works/pre-ipo"
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            onPreIPOClick();
          }}
        >
          {t('Pre-IPO')}
        </NavItemSecond>

        <NavItemSecond isDisabled={true}>{t('OTC')}</NavItemSecond>

        <NavItemSecond isDisabled={true}>{t('Stocks and ETF')}</NavItemSecond>
      </div>
    </Tooltip>
  );
}
